import * as React from "react";

const MOBILE_BREAKPOINT = 768;
const QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

const getIsMobile = () =>
  typeof window !== "undefined" && window.matchMedia(QUERY).matches;

export function useIsMobile() {
  // Leses med en gang, ikke først i en effekt. Før var første svar alltid
  // «ikke mobil», så på telefon startet hele desktop-appen (egen
  // QueryClient, layout og spørringer) før den ble revet ned og byttet ut
  // med mobilversjonen — dobbel oppstart og et synlig blink.
  const [isMobile, setIsMobile] = React.useState(getIsMobile);

  React.useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = () => setIsMobile(mql.matches);
    mql.addEventListener("change", onChange);
    // Bredden kan ha endret seg mellom første rendring og effekten.
    onChange();
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
